import classNames from 'classnames';
import {motion} from 'framer-motion';
import {FC} from 'react';
import styles from './MeinProgressBar.module.css';

interface IProps {
    value: number;
    total: number;
    height?: number | string;
    className?: string;
    classNameBar?: string;
    durationMs?: number;
    delayMs?: number;
    initialValue?: number;
}

export const MeinProgressBar: FC<IProps> = ({
    value,
    total,
    height = '0.5rem',
    className,
    classNameBar,
    durationMs = 800,
    delayMs = 0,
    initialValue = 0,
}) => {
    const getPercentage = () => {
        if (value >= total) {
            return 100;
        }
        return (value / total) * 100;
    };

    const getInitialValue = () => {
        if (initialValue >= total) {
            return 100;
        }
        return (initialValue / total) * 100;
    };

    return (
        <div
            className={classNames(styles.container, className)}
            style={{height}}
        >
            <motion.div
                className={classNames(styles.bar, classNameBar)}
                initial={{width: `${getInitialValue()}%`}}
                animate={{width: `${getPercentage()}%`}}
                transition={{
                    duration: durationMs / 1000,
                    delay: delayMs / 1000,
                    ease: 'easeOut',
                }}
            />
        </div>
    );
};
